import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  IPostSignNmbrRequestRequestBody,
  IPostSignNmbrRequestResponseBody,
} from "./postSignNmbrRequest.schema";

const URL = "/api/sign-nmbr-request";

export const postSignNmbrRequest =
  (axios: IAxiosInstance) =>
  async (requestBody: IPostSignNmbrRequestRequestBody) => {
    const response = await axios.noRetry.post<IPostSignNmbrRequestResponseBody>(
      URL,
      requestBody,
      {
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json",
        },
      }
    );
    const resData = response.data;

    if (resData.success) {
      return resData.data.token;
    }

    throw new Error("Failed to sign Nmbr request");
  };
